export const conversationUrlFor = (
  patient: Pick<Unpatient.User, 'id' | 'conversationId'> | null | undefined,
  hash = '',
): string => {
  if (!patient) return '/patients';
  const cid = patient.conversationId;
  if (!cid) return `/patients/${patient.id}`;
  const atIdx = cid.lastIndexOf('@');
  return `/conversations/${cid.slice(atIdx + 1)}/${cid.slice(0, atIdx)}/${patient.id}${hash}`;
};
